export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-joomla-863bbe611250b5c1ffa078bc0e7d65cc.svg";